import { KpiReq, KpiDef } from "../type/kpi";

import { formatDate } from "../../../lib/helper";

export class KpiAdapter {
  static toInputDTO(req: KpiReq): any {
    return req.node_attrs.filter((attr) => attr.value).map((attr) => attr.key);
  }

  static toOutputDTO(res: any): KpiDef {
    return (
      res?.map((attr: any) => ({
        id: attr.id,
        key: attr.key,
        ave: attr.ave,
        values:
          attr?.values?.map((val: any) => ({
            id: val.id,
            value: val.value,
            datetime: formatDate(val.datetime, "YY/MM"),
          })) || [],
      })) || []
    );
  }
}
